(ns ncr.etc.profile
  (:require
   [clojure.core.match :refer [match]]
   [cljs.core.async :as async :refer-macros [go]]
   [uix.core.alpha :as uix]
   [ncr.etc.util :as u]
   [ncr.backend :as b]
   [ncr.etc.pubsub :as ps]))

(deftype Wrapper [value update-fn]
  ISwap
  (-swap! [_ f]
    (update-fn f))
  (-swap! [_ f a]
    (update-fn f a))
  (-swap! [_ f a1 a2]
    (update-fn f a1 a2))
  (-swap! [_ f a1 a2 args]
    (apply update-fn f a1 a2 args))

  IReset
  (-reset! [_ newval]
    (update-fn (constantly newval)))

  IDeref
  (-deref [_] value))

(defmulti #^{:private true} read-backend!
  (fn [[store _] _]
    store))

(defmulti #^{:private true} write-backend!
  (fn [[store _] _]
    store))

(defmethod read-backend! :remote [[_ scope]]
  (b/!query [:profile_account_read {:scope scope}]))

(defmethod write-backend! :remote [[_ scope] value]
  (b/!mutation [:profile_account_write {:scope scope :data value}]))

(defmethod read-backend! :remote-cluster [[_ scope]]
  (b/!query [:profile_cluster_read {:scope scope}]))

(defmethod write-backend! :remote-cluster [[_ scope] value]
  (b/!mutation [:profile_cluster_write {:scope scope :data value}]))

(defn- storage-key [scope]
  (str "profile_" scope))

(defmethod read-backend! :local [[_ scope]]
  (go
    (js/localStorage.getItem (storage-key scope))))

(defmethod write-backend! :local [[_ scope] value]
  (go
    (js/localStorage.setItem (storage-key scope) value)
    value))

(defmethod read-backend! :session [[_ scope]]
  (go
    (js/sessionStorage.getItem (storage-key scope))))

(defmethod write-backend! :session [[_ scope] value]
  (go
    (js/sessionStorage.setItem (storage-key scope) value)
    value))

(defonce ^:private ephemeral
  (atom {}))

(defmethod read-backend! :ephemeral [[_ scope]]
  (go
    (get @ephemeral scope)))

(defmethod write-backend! :ephemeral [[_ scope] value]
  (go
    (swap! ephemeral assoc scope value)
    value))

(defonce #^{:private true} cache
  (atom {}))

(defn read-profile! [pspec default]
  (go
    (if (contains? @cache pspec)
      (@cache pspec)
      (let [read (or (u/transit-read (<! (read-backend! pspec))) default)]
        (swap! cache assoc pspec read)
        read))))

(defn write-profile! [pspec value & {:keys [no-notify?] :or {no-notify? false}}]
  (go
    ; NB local update before remote write
    (swap! cache assoc pspec value)

    (when-not no-notify?
      (ps/pub! [[::update pspec] value]))

    (let [written (u/transit-read (<! (write-backend! pspec (u/transit-write value))))]
      ; if transformed on the server - update again
      (when (not= written value)
        (swap! cache assoc pspec written)
        (when-not no-notify?
          (ps/pub! [[::update pspec] written])))
      written)))

(defn swap-profile! [pspec default f & args]
  (go
    (let [original (<! (read-profile! pspec default))]
      (<!
        (write-profile! pspec
          (apply f original args))))))

(defn use-profile [pspec default]
  (let
    [profile
     (ps/sub-reducer-map! nil
       {[::update pspec]
        (fn [_state value]
          value)})

     update!
     (uix/memo
       (fn []
         (fn [f & args]
           (let [updated (apply f @profile args)]
             (write-profile! pspec updated))))
       [pspec])]

    (uix/effect!
      (fn []
        (go
          (let [read (<! (read-profile! pspec default))]
            (reset! profile read))))
      [pspec])
    (Wrapper. @profile update!)))